const KEY_PREFIX = 'tf_whiteboard_draft_v1:';
const MAX_BYTES = 4 * 1024 * 1024;

const round = (n) => Math.round(n * 10) / 10;

const compactItem = (item) => (
  item.type === 'text'
    ? item
    : { ...item, points: item.points.map((p) => [round(p[0]), round(p[1]), p[2]]) }
);

export const draftKey = (userId) => `${KEY_PREFIX}${userId}`;

export const loadDraft = (userId) => {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(draftKey(userId));
    if (!raw) return null;
    const draft = JSON.parse(raw);
    return Array.isArray(draft.items) ? draft : null;
  } catch {
    return null;
  }
};

// Returns 'saved' | 'empty' | 'too_large' | 'error'
export const saveDraft = (userId, draft) => {
  if (!userId) return 'error';
  try {
    if (!draft.items.length) {
      localStorage.removeItem(draftKey(userId));
      return 'empty';
    }
    const payload = JSON.stringify({ ...draft, items: draft.items.map(compactItem), savedAt: Date.now() });
    if (payload.length > MAX_BYTES) return 'too_large';
    localStorage.setItem(draftKey(userId), payload);
    return 'saved';
  } catch {
    return 'error';
  }
};

export const removeDraft = (userId) => {
  if (userId) localStorage.removeItem(draftKey(userId));
};
